import { render, staticRenderFns } from "./GopSideMenu.vue?vue&type=template&id=78065924&scoped=true"
import script from "./GopSideMenu.vue?vue&type=script&lang=js"
export * from "./GopSideMenu.vue?vue&type=script&lang=js"
import style0 from "./GopSideMenu.vue?vue&type=style&index=0&id=78065924&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78065924",
  null
  
)

export default component.exports